import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import MarkdownRender from 'LuxKit/MarkdownRender'
import LargeContentToggle from 'components/Common/LargeContentToggle'

const Root = styled.div`
  padding-bottom: ${rem(16)};
  ${mediaQueryUp.tablet} {
    padding-bottom: ${rem(24)};
  }
`

const SectionHeader = styled.div`
  padding: ${rem(16)} 0;
  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

interface Props {
  inclusion: App.Tours.V2OfferInclusion
}

function TourV2UniqueInclusionSection(props: Props) {
  const { inclusion } = props
  const intl = useIntl()
  const readMoreText = intl.formatMessage({
    id: 'bdwG9yG0AlLVBQTT448r',
    defaultMessage: 'Read more',
    description: 'Toggle label to expand and show full inclusion description',
  })
  const readLessText = intl.formatMessage({
    id: '7HWAdCL_HRhrfIeWQCkJ',
    defaultMessage: 'Read less',
    description: 'Toggle label to collapse and hide inclusion description',
  })

  return (
    <Root>
      <SectionHeader>
        <Heading variant="heading5">{inclusion.title}</Heading>
      </SectionHeader>
      <LargeContentToggle maxHeight={85} showMoreText={readMoreText} showLessText={readLessText}>
        <MarkdownRender content={inclusion.body} />
      </LargeContentToggle>
    </Root>
  )
}

export default memo(TourV2UniqueInclusionSection)
